function currentOrigin() {
  return typeof window === "undefined" ? "http://localhost:3000" : window.location.origin;
}

const productionHost =
  typeof window !== "undefined" &&
  (window.location.hostname === "enkey.eu" ||
    window.location.hostname.endsWith(".enkey.eu"));

export const PUBLIC_ORIGIN =
  import.meta.env.VITE_PUBLIC_ORIGIN ||
  (productionHost ? "https://www.enkey.eu" : currentOrigin());

export const RESERVED_ORIGIN = PUBLIC_ORIGIN;

export function safeReturnUrl(
  value: string | null,
  fallback = `${RESERVED_ORIGIN}/crm`,
) {
  if (!value) return fallback;
  if (value.startsWith("/") && !value.startsWith("//")) return value;
  try {
    const url = new URL(value);
    if (url.origin === PUBLIC_ORIGIN) return url.href;
  } catch {
    // Invalid or non-absolute URL: use the safe fallback.
  }
  return fallback;
}
